import React from 'react';
import PropTypes from 'prop-types';

import { EditReviewContainer } from "./reviewStyles";
import PencilSVG from 'core/icons/PencilSVG';

const EditReviewButton = ({ onClick, hovered }) => (
	<EditReviewContainer onClick={onClick} hovered={hovered}>
		<PencilSVG/>
	</EditReviewContainer>
);

EditReviewButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	hovered: PropTypes.bool.isRequired,
};

export default EditReviewButton;
